/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography, Typography2 } from '@coursera/cds-core';

import { NotFound } from 'bundles/common/components/withNotFound';

import _t from 'i18n!nls/enterprise-ui';

export const NotAuthorized = () => {
  return (
    <NotFound
      description={
        <>
          {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
          <Typography variant="d2semibold">{_t('This doesn’t look like the right place...')}</Typography>
          <Typography2 component="p" css={{ marginTop: 'var(--cds-spacing-300)' }}>
            {_t(
              `It looks like you don’t have permission to view this page. It’s never too late to keep learning on Coursera―explore topics to continue`
            )}
          </Typography2>
          <Typography2 component="p" css={{ marginTop: 'var(--cds-spacing-300)' }}>
            {_t('Want to uncover more?')} {_t(' Accelerate your career with')}{' '}
            <Link href="/degrees">{_t('Online Degrees')}</Link>, {_t('grow together with')}{' '}
            <Link href="/enterprise">{_t('Coursera for Business')}</Link>, {_t('or explore the')}{' '}
            <Link href="https://blog.coursera.org/">{_t('Coursera Blog')}</Link>.
          </Typography2>
        </>
      }
    />
  );
};
